import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { TetrisGroup } from 'interfaces/api/tetrisGroups.interfaces'
import {
  CreateTetrisGroupParams,
  RemoveTetrisGroupParams,
  UpdateTetrisGroupParams,
} from 'interfaces/store/tetrisGroups.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllTetrisGroups = createAsyncThunk('tetrisGroups/getAllTetrisGroups', async (_, { rejectWithValue }) =>
  api.tetrisGroups.getAll().catch((error) => rejectWithValue(error.message)),
)

export const setTetrisGroupValidationErrors = createAction<ValidationErrorsApi | null>(
  'tetrisGroups/setTetrisGroupValidationErrors',
)

export const createTetrisGroup = createAsyncThunk(
  'tetrisGroups/createTetrisGroup',
  async (params: CreateTetrisGroupParams, { rejectWithValue, dispatch }) =>
    api.tetrisGroups
      .create(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setTetrisGroupValidationErrors(null))
        toast.success(Success.TetrisGroupCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setTetrisGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateTetrisGroup = createAsyncThunk(
  'tetrisGroups/updateTetrisGroup',
  async (params: UpdateTetrisGroupParams, { rejectWithValue, dispatch }) =>
    api.tetrisGroups
      .update(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setTetrisGroupValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setTetrisGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeTetrisGroup = createAsyncThunk(
  'tetrisSettings/removeTetrisGroup',
  async (params: RemoveTetrisGroupParams, { rejectWithValue }) =>
    api.tetrisGroups
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.TetrisGroupRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)

export const setSingleTetrisGroup = createAction<TetrisGroup | null>('tetrisGroups/setSingleTetrisGroup')
